import Glide from '@glidejs/glide'

class EventSlider {
	initiates() {

		const sliders = document.querySelectorAll('.glide');
		sliders.forEach((slider) => {
			if (slider.hasAttribute('data-slider-id') && slider.querySelectorAll('.glide__slide').length > 1) {
				new Glide(
					`[data-slider-id="${slider.dataset.sliderId}"]`,
					{
						peek: {before: 0, after: 130},
						gap: 20,
						breakpoints: {
							992: {
								peek: 0,
								gap: 10
							}
						}
					}
				).mount()
			}
			else {
				slider.querySelector('.glide__arrows').classList.add('d-md-none');
			}
		});
	}
}

export default new EventSlider();
